"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const textCommon_1 = require("../textCommon");
const Paragraph = styled_components_1.default.p `
  ${textCommon_1.textCommon}
  ${({ theme, contrast, bold, align }) => (0, styled_components_1.css) `
    color: ${contrast
    ? theme.palette.text.contrast
    : bitcoincom_pkg_theme_1.colors.solid.textOne};

    padding-bottom: ${theme.spacing.unit * 3}px;
    font-weight: ${bold ? 700 : 400};

    font-size: 14px;
    line-height: 24px;
    padding-bottom: 24px;

    text-align: ${align};

    ${bitcoincom_pkg_theme_1.media.md `
      font-size: 16px;
      line-height: 24px;
    `}

    ${bitcoincom_pkg_theme_1.media.xl `
      font-size: 20px;
      line-height: 40px;
    `}
  `}
`;
exports.default = Paragraph;
//# sourceMappingURL=Paragraph.js.map